import {
    LOGIN_ASYNC,
    BAD_USER_OR_PASS,
    CREATE_ACCOUNT_ASYNC,
    UPDATE_ACCOUNT_ASYNC,
    UPDATE_ACCOUNT_LOCAL_STORE,
    STORE_USER_CREDS,
    LOGOUT
} from '../actions/user';

const initState = {
    gameRunning: false,
    userLoggedIn: false,
    uuid: '',
    firstName: '',
    lastName: '',
    gamertag: '',
    password: '',
    email: ''
};

export const  userReducer = (state = initState, action) => {
    switch(action.type){
        case LOGIN_ASYNC:
            console.log('LOGIN_ASYNC');
            break;

        case BAD_USER_OR_PASS:
            console.log('BAD_USER_OR_PASS - Reducer');

            document.getElementById('js-user').value='';
            document.getElementById('js-user').placeholder = 'User not found or incorrect';
            document.getElementById('js-password').value='';
            document.getElementById('js-password').placeholder = 'Password not found or incorrect';

            document.getElementById('js-user').style.backgroundColor = '#f0ecbe';
            document.getElementById('js-password').style.backgroundColor = '#f0ecbe';

            return state;

        case CREATE_ACCOUNT_ASYNC:
            console.log('Create Account');
            console.log(action);
            return state;

        case UPDATE_ACCOUNT_ASYNC:
            console.log('Updating account');
            break;

        case UPDATE_ACCOUNT_LOCAL_STORE:
            console.log('UPDATE_ACCOUNT_LOCAL_STORE');
            console.log(action.asyncPayload);

            const {firstName, lastName, gamertag, password, email} = action.asyncPayload;
            console.log(firstName, lastName, gamertag, password, email);

            return {
                ...state,
                firstName,
                lastName,
                gamertag,
                password,
                email
            };

        case STORE_USER_CREDS:
            let json = action.jsonObj[0];
            return {
                ...state,
                userLoggedIn: true,
                uuid: json.uuid,
                firstName: json.firstName,
                lastName: json.lastName,
                gamertag: json.gamertag,
                password: json.password,
                email: json.email
            };

        case LOGOUT:
            return {
                ...state,
                gameRunning: false,
                userLoggedIn: false,
                uuid: '',
                firstName: '',
                lastName: '',
                gamertag: '',
                password: '',
                email: ''
            };

        default:
            return state;
    }
};


// WEBPACK FOOTER //
// ./src/reducers/user.js